// pages/States.tsx
import React from "react";
import Button from "../components/Button";
import ConfirmationDialog from "../components/ConfirmationDialog";
import DataTableView from "../components/DataTableView2";
import Input from "../components/Input";
import AddStateModal from "../components/state/AddStateModal";
import useStates from '../hooks/logics/suppport/use-state-dashboard';

export type StateType = {
  _id: string;
  name: string;
  symbol: string;
};

const States = () => {
  const {
    states,
    totalPages,
    isLoading,
    isDeletingState,
    currentPage,
    setCurrentPage,
    search,
    setSearch,
    selectedStateId,
    setSelectedStateId,
    isAddingState,
    setIsAddingState,
    searchRef,
    handleSearch,
    handleClear,
    handleStateDelete,
    refetch,
  } = useStates();

  const columns = [
    {
      header: "Name",
      className: "md:p-0 md:pl-10",
      cellClassName: "max-w-[50px]",
      accessor: (state: StateType) => (
        <div className="md:!pl-7">{state.name || "N/A"}</div>
      ),
    },
    {
      header: "Symbol",
      accessor: (state: StateType) => state.symbol || "N/A",
    },
    {
      header: "Action",
      accessor: (state: StateType) => (
        <Button
          onClick={() => setSelectedStateId(state._id)}
          variant="ghost"
          className="text-red-600"
        >
          Delete
        </Button>
      ),
    },
  ];

  return (
    <>
      <div className="w-full h-full">
        <div className="pb-4 flex flex-col justify-center font-inter bg-gray-100">
          <form onSubmit={handleSearch} className="w-full flex flex-col md:flex-row gap-4">
            <div className="w-full flex flex-row gap-x-2 md:gap-x-4 md:justify-end">
              <Input
                ref={searchRef}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                containerClassName="w-2/3 h-full md:w-auto"
                outerClassName="h-full"
                className="w-full md:w-52 outline-none input-primary h-8 md:h-10 rounded-lg"
                placeholder="Search"
              />
              <Button disabled={!search} type="submit" className="w-1/3 md:w-32 min-h-0 h-8 md:h-10">
                Search
              </Button>
            </div>
            <div className="w-full md:w-min flex flex-row gap-x-2 md:gap-x-4 md:justify-end">
              <Button disabled={!search} type="button" onClick={handleClear} className="flex-1 md:flex-none md:w-32 min-h-0 h-8 md:h-10">
                Clear
              </Button>
              <Button onClick={() => setIsAddingState(true)} className="flex-1 md:flex-none md:w-32 min-h-0 h-8 md:h-10">
                Add state
              </Button>
            </div>
          </form>
        </div>

        <DataTableView
          data={states}
          columns={columns}
          isFetching={isLoading}
          emptyStateMessage="No data found"
          totalPages={totalPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>

      <AddStateModal
        isVisible={isAddingState}
        onHide={() => setIsAddingState(false)}
        onSuccess={refetch}
      />

      <ConfirmationDialog
        handleClick={handleStateDelete}
        isSubmitButtonDisabled={isDeletingState}
        isSubmitting={isDeletingState}
        text="Are you sure you want to delete this state?"
        isVisible={selectedStateId !== ""}
        onHide={() => setSelectedStateId("")}
      />
    </>
  );
};

export default States;